import React, { useState } from "react";

const containerStyle = {
  display: "flex",
  alignItems: "center",
  gap: "16px",
};

const starContainerStyle = {
  display: "flex",

  gap: "4px",
};

const textStyle = {
  lineHeight: "1",
  margin: "0",
};

export default function StarList({
  maxRating = 5,
  color,
  size,
  message = [],
  setUserRating,
}) {
  const [rating, setRating] = useState("");
  const [hoverRating, setHoverRating] = useState("");

  function addRatingClick(i) {
    setRating(i);
    setUserRating(i);
  }

  return (
    <div style={containerStyle}>
      <div style={starContainerStyle}>
        {Array.from({ length: maxRating }, (_, i) => (
          // <span>S{i + 1}</span>
          <Star
            key={i}
            rating={rating}
            addRatingClick={() => addRatingClick(i + 1)}
            isTrue={rating >= i + 1 || hoverRating >= i + 1}
            onHoverEnter={() => setHoverRating(i + 1)}
            onHoverExit={() => setHoverRating("")}
            color={color}
            size={size}
          />
        ))}
      </div>
      <p style={textStyle}>
        {message.length
          ? message[hoverRating ? hoverRating - 1 : rating - 1]
          : hoverRating
          ? hoverRating
          : rating
          ? rating
          : ""}
      </p>
    </div>
  );
}

// message.length ? message[rating] : "" || rating || "" || hoverRating

function Star({
  addRatingClick,
  isTrue,
  onHoverEnter,
  onHoverExit,
  color = "green",
  size = "48",
}) {
  const starStyle = {
    width: `${size}px`,
    height: `${size}px`,
    display: "block",
    cursor: "pointer",
  };
  return (
    <span
      style={starStyle}
      onClick={addRatingClick}
      onMouseEnter={onHoverEnter}
      onMouseLeave={onHoverExit}
    >
      {isTrue ? (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 20 20"
          fill={color}
          stroke={color}
        >
          <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
        </svg>
      ) : (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke={color}
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="{2}"
            d="M11.049 2.927c.3-.921 1.603-.921 1.902 0l1.519 4.674a1 1 0 00.95.69h4.915c.969 0 1.371 1.24.588 1.81l-3.976 2.888a1 1 0 00-.363 1.118l1.518 4.674c.3.922-.755 1.688-1.538 1.118l-3.976-2.888a1 1 0 00-1.176 0l-3.976 2.888c-.783.57-1.838-.197-1.538-1.118l1.518-4.674a1 1 0 00-.363-1.118l-3.976-2.888c-.784-.57-.38-1.81.588-1.81h4.914a1 1 0 00.951-.69l1.519-4.674z"
          />
        </svg>
      )}
    </span>
  );
}
